var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,22C20.646,22 22,20.646 22,19L22,8C22,7.735 21.895,7.48 21.707,7.293L16.707,2.293C16.52,2.105 16.265,2 16,2L5,2C3.354,2 2,3.354 2,5L2,19C2,20.646 3.354,22 5,22L19,22ZM8,4L8,7L15,7C15.552,7 16,7.448 16,8C16,8.552 15.552,9 15,9L7,9C6.448,9 6,8.552 6,8L6,4L5,4C4.451,4 4,4.451 4,5C4,5 4,19 4,19C4,19.549 4.451,20 5,20L6,20L6,13C6,12.448 6.448,12 7,12L17,12C17.552,12 18,12.448 18,13L18,20L19,20C19.549,20 20,19.549 20,19C20,19 20,8.414 20,8.414C20,8.414 15.586,4 15.586,4L8,4ZM8,20L16,20L16,14C16,14 8,14 8,14L8,20Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.5b65bc79.svg";
export { ForwardRef as ReactComponent };